<template>
    <div class="container">
        <mt-header fixed :title="title" class="head" >
           <router-link to="/imgupdate" slot="left">
            <mt-button icon='back'></mt-button>
           </router-link>
            <mt-button slot="right" v-show="auth.editable" @click="commit">提交</mt-button>
        </mt-header>
      <form>
        <div class="form">
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              楼盘名称
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value ">
                      <input type="text" @change="autoSave('village',village)" placeholder="请填写楼盘名称" v-model="village">
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              客户
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value ">
                      <input type="text" @change="autoSave('customerName',customerName)" placeholder="请填写客户姓名" v-model="customerName">
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              客户联系方式
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value ">
                      <input type="tel" @change="autoSave('customerPhone',customerPhone)" placeholder="请填写客户联系方式" v-model="customerPhone">
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              项目地址
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value ">
                    <input type="text" @change="autoSave('address',address)" placeholder="请填写项目地址" v-model="address">
                </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              勘察人员
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value ">
                      <input type="text" @change="autoSave('surveyName',surveyName)" placeholder="请填写勘察人员姓名" v-model="surveyName">
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              勘察人员联系方式
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value ">
                      <input type="text" @change="autoSave('surveyPhone',surveyPhone)" placeholder="请填写勘察人员联系方式" v-model="surveyPhone">
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              是否选择维修
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value">
                     <mt-switch v-model="isRepair"></mt-switch>
                  </span>
            </div>
          </div>
          <div class="item-group c_m_b_10 bg_white">
            <div class="item-title c_nowrap">
              维修方案
            </div>
            <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                  <span class="item-value">
                     <mt-switch v-model="plan"></mt-switch>
                  </span>
            </div>
          </div>
        </div>
        <div class="table">
          <div class="table-container">
            <div class="table-header">屋面</div>
            <div class="table-body">
              <div class="table-group">
                <div class="table-title">屋面类型：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                    <label class="" v-for="(value,key) in house.type_temp">
                        {{key}}<input type="checkbox"  @change="autoSave('house_type',house.type_temp)"  v-model="house.type_temp[key]" />
                    </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">维修部位：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in house.part_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('house_part',house.part_temp)"  v-model="house.part_temp[key]" />
                  </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">渗漏原因：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in house.reason_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('house_reason',house.reason_temp)"  v-model="house.reason_temp[key]" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container">
            <div class="table-header">卫生间</div>
            <div class="table-body">
              <div class="table-group">
                <div class="table-title">卫生间类型：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                    <label class="" v-for="(value,key) in toilet.type_temp">
                        {{key}}<input type="checkbox"  @change="autoSave('toilet_type',toilet.type_temp)"  v-model="toilet.type_temp[key]" />
                    </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">维修部位：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in toilet.part_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('toilet_part',toilet.part_temp)"  v-model="toilet.part_temp[key]" />
                  </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">渗漏原因：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in toilet.reason_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('toilet_reason',toilet.reason_temp)"  v-model="toilet.reason_temp[key]" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container">
            <div class="table-header">窗户</div>
            <div class="table-body">
              <div class="table-group">
                <div class="table-title">窗户类型：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                    <label class="" v-for="(value,key) in windows.type_temp">
                        {{key}}<input type="checkbox"  @change="autoSave('windows_type',windows.type_temp)"  v-model="windows.type_temp[key]" />
                    </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">维修部位：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in windows.part_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('windows_part',windows.part_temp)"  v-model="windows.part_temp[key]" />
                  </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">渗漏原因：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in windows.reason_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('windows_reason',windows.reason_temp)"  v-model="windows.reason_temp[key]" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-contaier">
            <div class="table-header">渗漏时长</div>
            <div class="table-body">
              <div class="table-group">
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in time.temp">
                    {{key}}<input type="radio" name="form_time" :value="key" @change="autoSave('time',time.value)"  v-model="time.value" />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container">
              <div class="table-header">维修范围</div>
              <div class="table-body">
                <div class="table-group c_flex">
                  <div class="table-title">屋面：</div>
                  <div class="table-content c_flex_1" :class="auth.editable?'':'c_no_pointer'">
                      <input type="text" @change="autoSave('house_area',house_area)"  v-model="house_area" />
                  </div>
                </div>
                <div class="table-group c_flex">
                  <div class="table-title">卫生间：</div>
                  <div class="table-content c_flex_1" :class="auth.editable?'':'c_no_pointer'">
                      <input type="text" @change="autoSave('toilet_area',toilet_area)"  v-model="toilet_area" />
                  </div>
                </div>
                <div class="table-group c_flex">
                  <div class="table-title">窗户：</div>
                  <div class="table-content c_flex_1" :class="auth.editable?'':'c_no_pointer'">
                      <input type="text" @change="autoSave('windows_area',windows_area)"  v-model="windows_area" />
                  </div>
                </div>
              </div>
          </div>
          <div class="table-container">
            <div class="table-header">维修做法</div>
            <div class="table-body">
              <div class="table-group">
                <div class="table-title">屋面：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in method.house_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('method_house',method.house_temp)"  v-model="method.house_temp[key]" />
                  </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">卫生间：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in method.toilet_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('method_toilet',method.toilet_temp)"  v-model="method.toilet_temp[key]" />
                  </label>
                </div>
              </div>
              <div class="table-group">
                <div class="table-title">窗户：</div>
                <div class="table-content" :class="auth.editable?'':'c_no_pointer'">
                  <label class="" v-for="(value,key) in method.windows_temp">
                    {{key}}<input type="checkbox"  @change="autoSave('method_windows',method.windows_temp)"  v-model="method.windows_temp[key]" />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="procedure bg_white ">
          <div class="procedure-group">
            <div class="procedure-title">整体大面({{img_whole.length}}/3)</div>
            <div class="procedure-content">
              <div class="c_rela procedure-img" v-for="(n,index) in img_whole" :key="index" v-if="index<3">
                <div class="imgdel" v-show="auth.editable" @click="delClick('img_whole',index)">×</div>
                <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
              </div>
              <update-file v-show="(img_whole.length<3) && auth.editable" @fileChange="getUrl($event,'img_whole')"></update-file>
            </div>
            <div class="procedure-memo">
              <div>1、	照片：不同角度体现整体的照片3张</div>
              <div>2、	合格要求：从不同角度拍照，可以看出项目的整体布局构造</div>
            </div>
          </div>
          <div class="procedure-group">
            <div class="procedure-title">渗漏部位({{img_part.length}}/3)</div>
            <div class="procedure-content">
              <div class="c_rela procedure-img" v-for="(n,index) in img_part" :key="index" v-if="index<3">
                <div class="imgdel" v-show="auth.editable" @click="delClick('img_part',index)">×</div>
                <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
              </div>
              <update-file v-show="(img_part.length<3) && auth.editable" @fileChange="getUrl($event,'img_part')"></update-file>
            </div>
            <div class="procedure-memo">
              <div>1、	照片：室内渗漏部位的照片3张</div>
              <div>2、	合格要求：可明显看出部位渗漏损坏情况即可</div>
            </div>
          </div>
          <div class="procedure-group">
            <div class="procedure-title">细部节点({{img_detail.length}}/3)</div>
            <div class="procedure-content">
              <div class="c_rela procedure-img" v-for="(n,index) in img_detail" :key="index" v-if="index<3">
                <div class="imgdel" v-show="auth.editable" @click="delClick('img_detail',index)">×</div>
                <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
              </div>
              <update-file v-show="(img_detail.length<3) && auth.editable" @fileChange="getUrl($event,'img_detail')"></update-file>
            </div>
            <div class="procedure-memo">
              <div>1、	照片：屋面：落水口、阴阳角、管根、女儿墙、变形缝、分隔缝、天沟（根据不同屋面不同构造拍3张）</div>
              <div>卫生间：地漏，下水管、排污管周边，过门石与地砖交接部位，墙地面交接部位</div>
              <div>窗户：密封胶是否开裂、窗框、窗体主框墙面保温情况（可在一层空调穿墙管部判断）</div>
              <div>2、	合格要求：照片清晰可见，可以看出该部位的结构及防水状况</div>
            </div>
          </div>
        </div>
      </form>
      <!--图片显示-->
      <c-imgshow @part_close="part_close" :ispart_imgshow="ispart_imgshow" :imgshow_url="imgshow_url">
      </c-imgshow>
    </div>
</template>
<script>
import axios from 'axios'
import {Indicator, MessageBox} from 'mint-ui';
import UpdateFile from './update-file';
import CImgshow from './c-imgshow';
export default {
    components:{UpdateFile,CImgshow},
    data(){
        return{
          qiniu:this.$$api.mobile.qiniuDownload,
          img_whole:[],
          img_part:[],
          img_detail:[],
          title:'',
          sid:'',
          billid:'',
          formid:'',
          // 权限控制
          auth:{
            //是否开始自动保存
            isAutoSave:false,
            //是否有提交权限
            editable:false,
            //是否-- 可以提交
            isCommit:true,
          },
          // 图片显示
          ispart_imgshow:false,
          imgshow_url:'',
          imgNum:{
            img_whole:3,
            img_part:3,
            img_detail:3
          },
          //勘察单数据  ？？？？？？？
          house: {
            type_temp: {
              "普通屋面": false,
              "上人露台": false,
              "斜坡屋面": false,
              "金属顶": false,
              "采光顶": false,
            },
            part_temp:{
              "女儿墙": false,
              "落水口": false,
              "外墙保温":false,
              "变形缝":false,
              "排气孔":false,
              "排风道":false,
              "出入口":false,
              "设备墩":false,
              "老虎窗":false,
              "其他":false,
            },
            reason_temp:{
              "未进行防水处理": false,
              "未进行防水处理":false,
              "材料老化":false,
              "材料开裂":false,
              "排水不畅有积水":false,
              "细部节点处理不当":false,
              "阴阳角":false,
              "出入口":false,
              "水落口":false,
              "设备基座":false,
              "排气孔根部":false,
            },
          },
          // 卫生间
          toilet: {
            type_temp: {
              "普通卫生间": false,
              "沉箱卫生间": false,
            },
            part_temp:{
              "蹲式": false,
              "坐式": false,
              "洗手盆": false,
              "地漏": false,
              "淋浴": false,
              "热水器": false,
              "地暖": false,
              "浴缸": false,
              "洗衣机": false,
              "其他": false,
            },
            reason_temp:{
              "未进行防水处理": false,
              "结构物理开裂": false,
              "瓷砖缝隙 ": false,
              "过门石周边洇湿": false,
              "管根周圈渗水": false,
              "楼板周边渗水": false,
            },
          },
          // 窗户
          windows: {
            type_temp: {
              "窗户（外墙有保温）": false,
              "窗户（外墙无保温）":false,
            },
            part_temp:{
              "齐平式": false,
              "内凹式": false,
              "外突式": false,
              "外墙砖": false,
              "外墙漆": false,
              "真石漆": false,
              "滴水檐 ": false,
              "外护栏": false,
            },
            reason_temp:{
              "未进行防水处理": false,
              "外墙装饰材料老化": false,
              "密封材料老化开裂": false,
              "装饰材料起皮脱落": false,
            },
          },
          time:{
            temp:{
              "一年以内":false,
              "2-3年":false,
              "2年-5年":false,
              "其他":false,
            }
          },//渗透时长
          // 维修范围
          house_area:'',
          toilet_area:'',
          windows_area:'',
          // 维修方案
          method:{
            house_temp:{
              "饰面层":false,
              "结合层":false,
              "保温层":false,
              "防水层":false,
              "找坡层":false,
              "找平层":false,
              "其他":false,
            },
            toilet_temp:{
              "免拆":false,
              "局拆":false,
              "整拆":false,
            },
            windows_temp:{
              "不开槽":false,
              "开槽":false,
            },
          },
          isRepair:false,//是否选择维修
          plan:false,//维修方案
          village:'',//楼房名称
          surveyName:'',//勘察人员
          surveyPhone:'',//勘察人员
          customerName:'',//业主
          customerPhone:'',//业主
          address:'',//项目地址

          // 用户数据
          simpleuser:{},
        }
    },

    mounted(){
      var obj = JSON.parse(localStorage['obj']);
      var procedure = obj.procedure;
      this.sid = procedure.billbid;
      this.billid = procedure.billid;
      this.formid = procedure.formid;
      this.itemid = procedure.itemid;
      this.title = procedure.itemname;
      this.load();
      this.getAuth();
    },
    computed:{

    },
    methods:{
        // 获取工序详情
        load:function(){
          var $that = this;
          this.$ajax.get(this.$$api.mobile.getProcedureDetail,{
            'sid':this.sid,
            'formid':this.formid
          },function (res) {
            if(res.status ==200) {
              var obj = res.data.detailMsg.data;
              $that.village = obj.village;
              $that.plan = (obj.plan == 'true')||false;
              $that.isRepair = (obj.isRepair == 'true')||false;

              $that.surveyName = obj.surveyName;
              $that.surveyPhone = obj.surveyPhone;
              $that.customerName = obj.customerName;
              $that.customerPhone = obj.customerPhone;
              $that.address = obj.address;

              $that.img_whole = obj.img_whole ? (obj.img_whole.split(',')||[]):[];
              $that.img_part = obj.img_part ? (obj.img_part.split(',')||[]):[];
              $that.img_detail = obj.img_detail ? (obj.img_detail.split(',')||[]):[];
              //?????????????  反显
              $that.time.value = obj.time;

              $that.house.type_temp = obj.house_type ? JSON.parse(obj.house_type) : $that.house.type_temp ;
              $that.house.part_temp = obj.house_part ? JSON.parse(obj.house_part) : $that.house.part_temp ;
              $that.house.reason_temp = obj.house_reason ? JSON.parse(obj.house_reason) : $that.house.reason_temp ;

              $that.toilet.type_temp = obj.toilet_type ? JSON.parse(obj.toilet_type) : $that.toilet.type_temp ;
              $that.toilet.part_temp = obj.toilet_part ? JSON.parse(obj.toilet_part) : $that.toilet.part_temp ;
              $that.toilet.reason_temp = obj.toilet_reason ? JSON.parse(obj.toilet_reason) : $that.toilet.reason_temp ;

              $that.windows.type_temp = obj.windows_type ? JSON.parse(obj.windows_type) : $that.windows.type_temp ;
              $that.windows.part_temp = obj.windows_part ? JSON.parse(obj.windows_part) : $that.windows.part_temp ;
              $that.windows.reason_temp = obj.windows_reason ? JSON.parse(obj.windows_reason) : $that.windows.reason_temp ;

              $that.house_area = obj.house_area;
              $that.toilet_area = obj.toilet_area;
              $that.windows_area = obj.windows_area;

              $that.method.house_temp =  obj.method_house ? JSON.parse(obj.method_house) : $that.method.house_temp ;
              $that.method.toilet_temp =  obj.method_toilet ? JSON.parse(obj.method_toilet) : $that.method.toilet_temp ;
              $that.method.windows_temp =  obj.method_windows ? JSON.parse(obj.method_windows) : $that.method.windows_temp ;

              setTimeout(function(){
                $that.auth.isAutoSave = true;
              },500);
            }
          });
        },
        // 获取勘察单 --  原数据
        customerLoad:function(){
          var $that = this;
          var billid = this.billid;
          this.$ajax.get(this.$$api.mobile.getSimpleuser,{
            billid:billid,
          },function (res) {
            if(res.status ==200) {
              var obj = res.data.detailMsg.data;
              if(obj){
                if(!$that.village){ $that.village = obj.community; $that.autoSave('village',obj.community); }
                if(!$that.customerName){ $that.customerName = obj.name; $that.autoSave('customerName',obj.name);}
                if(!$that.customerPhone){ $that.customerPhone =  obj.phone; $that.autoSave('customerPhone',obj.phone);}
                if(!$that.surveyName){ $that.surveyName =  obj.user_name; $that.autoSave('surveyName',obj.user_name);}
                if(!$that.surveyPhone){ $that.surveyPhone =  obj.user_mobile; $that.autoSave('surveyPhone',obj.user_mobile);}
                var addr =  (obj.province?obj.province:'') +(obj.city ? obj.city :'')+(obj.district ? obj.district :'');
                if(!$that.address){ $that.address = addr; $that.autoSave('address',addr);}
              }
            }
          })
        },
        // 获取当前用户权限
        getAuth:function(){
          var $that = this;
          this.$ajax.get(this.$$api.mobile.getProcedureAuth,{
            'itemid':this.itemid,
            'billbid':this.sid,
          },function (res) {
            if(res.status ==200) {
              var obj = res.data.detailMsg.data;
              $that.auth.editable = obj.editable == 'Y'? true:false;
              if(obj.editable=='Y'){
                $that.customerLoad();
              }
            }
          });
        },
        // 自动保存
        autoSave(type,value){
          if((typeof value).toLocaleLowerCase() == 'object'){
            value = JSON.stringify(value);
          }
          if(type && this.sid &&this.formid && this.auth.isAutoSave) {
            this.$ajax.get(this.$$api.mobile.saveProcedure, {
              'sid':this.sid,
              'formid':this.formid,
              'attribute':type,
              'value':value
            },response=>{
              if (response.status >= 200 && response.status < 300) {
                // console.log(response);
              } else {
                // console.log(response,this.sid);
              }
            });
          }
        },
        // 提交
        commit:function () {
          var $that = this;
          //判断 --
          // if(!this.village){ this.$toast("请填写楼盘名称"); return;}
          if(!this.auth.isCommit){return;}
          this.auth.isCommit = false;
          this.auth.editable = false;
          this.$ajax.post(this.$$api.mobile.commitProcedure,{
            'sid':this.sid,
            'formid':this.formid,
          },function (res) {
            $that.$router.push('/imgupdate');
          },function () {
            $that.auth.isCommit = true;
            $that.auth.editable = true;
          });
        },
        authClick:function(){
          // this.auth.isAutoSave=true;
          this.auth.editable=true;
          this.auth.isCommit=true;
        },

      // 上传图片
      imgFile:function(type,file,fun){
        var $that = this;
        this.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getimgtoken,{},function (res) {
          if(res.status == 200){
            var token = res.data.token;
            var fileid = res.data.fileid;
            let param = new FormData(); //创建form对象
            param.append('file',file,file.name);//通过append向form对象添加数据
            param.append('chunk','0');//添加form表单中其他数据
            param.append('token',token);//添加form表单中其他数据
            param.append('key',fileid);//添加form表单中其他数据
            let config = {
              headers:{'Content-Type':'multipart/form-data'}
            };
            axios.post($that.$$api.mobile.qiniuUpload,param,config)
              .then(data=>{
                var key = data.data.key;
                if(fun)fun(key);
                $that.$indicator.close();
              });
          }
        });

      },
      // 删除图片
      delClick:function(type,index){
        if(type == 'img_whole'){
          var arr = this.img_whole;
          arr.splice(index,1);
          this.img_whole = arr;
        }else if(type == 'img_part'){
          var arr = this.img_part;
          arr.splice(index,1);
          this.img_part = arr;
        }else if(type == 'img_detail'){
          var arr = this.img_detail;
          arr.splice(index,1);
          this.img_detail = arr;
        }
      },
      getUrl(e,val){
        var $that = this;
        // var file = e.files[0];
        var file =this.$comm.toBase64(e.base64);
        if(val=='img_whole'){
          this.imgFile('img_whole',file,function (url) {
            $that.img_whole.push(url);
          });
          Indicator.close();
        }else if(val=='img_part'){
          this.imgFile('img_part',file,function (url) {
            $that.img_part.push(url);
          });
          Indicator.close();
        }else if(val=='img_detail'){
          this.imgFile('img_detail',file,function (url) {
            $that.img_detail.push(url);
          });
          Indicator.close();
        }
      },
      imgShowClick:function (e) {
        var url = e.currentTarget.dataset.src;
        if(url){
          this.imgshow_url = url;
          this.ispart_imgshow = true;
        }
      },
      part_close:function (value) {
        this.ispart_imgshow = value;
      },

    },
    watch:{
       plan(){
         if(this.auth.isAutoSave && this.auth.editable){
           this.autoSave('plan',this.plan);
         }
       },
       isRepair(){
         if(this.auth.isAutoSave && this.auth.editable){
           this.autoSave('isRepair',this.isRepair);
         }
       },
      img_whole(){
        this.autoSave('img_whole',(this.img_whole).join(','));
      },
      img_part(){
        this.autoSave('img_part',(this.img_part).join(','));
      },
      img_detail(){
        this.autoSave('img_detail',(this.img_detail).join(','));
      },
    }
}
</script>
<style scoped>
  .container{
    font-size:4vw;
  }
  ::-webkit-input-placeholder {
    font-size: 3vw;
    color: rgb(184,195,206);
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title {
    width: 50%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 50%;
    text-align: right;
    font-size: 4vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 4vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
    color:#000;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
  }
  >>> .mint-switch{
    justify-content: flex-end;
  }



  /*table*/
  .table .table-header{
    width: 100%;
    box-sizing: border-box;
    padding: 3.226vw;
    background: rgb(184,195,206);
    color: #fff;
    font-size: 4vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .table-title{
    /*width: 10%;*/
  }
  .table-body{
    padding: 3.226vw;
    background: #fff;
  }
  .table-body .item-value{
    width: 100%;
  }
  /*.table-body input{*/
    /*background: transparent;*/
  /*}*/
  .table-group{
    margin-bottom: 3vw;
  }
  .table-content{
    flex-wrap: wrap;
    display: flex;
  }
  .table-content label{
    margin-left: 3vw;
    margin-top: 3vw;
    display: flex;
    align-items: center;
  }
  .table-content input[type='text']{
    width: 100%;
    background: transparent;
    border: 0;
    outline: none;
    border-bottom: 1px solid #ccc;
  }

</style>






// WEBPACK FOOTER //
// src/components/surveyform.vue